export let wordlist = {
    // General
    "loading": {
        "en": "loading",
        "fr": "chargement",
        "de": "laden",
        "es": "cargando",
        "it": "caricamento",
        "nl": "laden",
        "pt": "carregando"
    },

    "save": {
        "en": "save",
        "fr": "enregistrer",
        "de": "speichern",
        "es": "guardar",
        "it": "salvare",
        "pt": "guardar",
        "nl": "opslaan"
    },

    "back" : {
        "en": "back",
        "fr": "retour",
        "de": "zurück",
        "es": "atrás",
        "it": "indietro",
        "nl": "terug",
        "pt": "voltar"
    }, 

    // Login page

    "email": {
        "en": "email",
        "fr": "e-mail",
        "de": "e-mail",
        "es": "correo electrónico",
        "it": "email",
        "nl": "e-mail",
        "pt": "email"
    },
    "password": {
        "en": "password",
        "fr": "mot de passe",
        "de": "passwort",
        "es": "contraseña",
        "it": "password",
        "nl": "wachtwoord",
        "pt": "palavra-passe"
    },
    "login": {
        "en": "login",
        "fr": "se connecter",
        "de": "anmeldung",
        "es": "iniciar sesión",
        "it": "accedi",
        "nl": "inloggen",
        "pt": "iniciar sessão"
    },
    "forgot password?": {
        "en": "forgot password?",
        "fr": "mot de passe oublié ?",
        "de": "passwort vergessen?",
        "es": "¿olvidaste tu contraseña?",
        "it": "hai dimenticato la password?",
        "nl": "wachtwoord vergeten?",
        "pt": "esqueceu-se da palavra-passe?"
    },
    "don't have a WyneLover account yet?": {
        "en": "don't have a WyneLover account yet?",
        "fr": "vous n'avez pas encore de compte WyneLover ?",
        "de": "Haben Sie noch kein WyneLover-Konto?",
        "es": "¿aún no tienes una cuenta en WyneLover?",
        "it": "non hai ancora un account WyneLover?",
        "nl": "heb je nog geen WyneLover-account?",
        "pt": "ainda não tem uma conta WyneLover?"
    },
    "register": {
        "en": "register",
        "fr": "s'inscrire",
        "de": "registrieren",
        "es": "regístrate",
        "it": "registrati",
        "nl": "registreren",
        "pt": "registar"
    },
    "a simple tool to manage your winecellar": {
        "en": "a simple tool to manage your winecellar",
        "fr": "un outil simple pour gérer votre cave à vin",
        "de": "ein einfaches Tool zur Verwaltung Ihres Weinkellers",
        "es": "una herramienta sencilla para gestionar su bodega",
        "it": "uno strumento semplice per gestire la tua cantina",
        "nl": "een eenvoudige tool om je wijnkelder te beheren",
        "pt": "uma ferramenta simples para gerir a sua adega"
    },

    "funware for wine lovers developed and ©copyrighted by N'JOY Information Technology": {
        "en": "funware for wine lovers by N'JOY Information Technology ©",
        "fr": "funware pour les amateurs de vin par N'JOY Information Technology ©",
        "de": "funware für weinliebhaber von N'JOY Information Technology ©",
        "es": "funware para amantes del vino por N'JOY Information Technology ©",
        "it": "funware per gli amanti del vino di N'JOY Information Technology ©",
        "nl": "funware voor wijnliefhebbers door N'JOY Information Technology ©",
        "pt": "funware para amantes do vinho por N'JOY Information Technology ©"
    },

    // Welcome page

    "Welcome": {
        "en": "Welcome",
        "fr": "Bienvenue",
        "de": "Willkommen",
        "es": "Bienvenido",
        "it": "Benvenuto",
        "nl": "Welkom",
        "pt": "Bem-vindo"
    },

    "Thank you for joining WyneCellar. Your wine journey starts here.": {
        "en": "Thank you for joining WyneCellar. Your wine journey starts here.",
        "fr": "Bienvenue chez WyneCellar. Commencez dès aujourd’hui à explorer et organiser votre collection de vins.",
        "de": "Willkommen bei WyneCellar. Entdecken und verwalten Sie Ihre Weinsammlung mit Freude.",
        "es": "Bienvenido a WyneCellar. Empieza a disfrutar y organizar tu colección de vinos.",
        "it": "Benvenuto in WyneCellar. Inizia a scoprire e gestire la tua collezione di vini.",
        "nl": "Welkom bij WyneCellar. Ontdek, organiseer en geniet van jouw wijncollectie.",
        "pt": "Bem-vindo à WyneCellar. Comece hoje a explorar e organizar a sua coleção de vinhos."
    },

    "We're delighted to help you organize, manage and enjoy your wine collection.": {
        "en": "We're delighted to help you organize, manage and enjoy your wine collection.",
        "fr": "Nous sommes ravis de vous accompagner dans la gestion et la découverte de votre cave à vins.",
        "de": "Wir freuen uns darauf, Sie bei der Verwaltung und Entdeckung Ihrer Weinsammlung zu unterstützen.",
        "es": "Estamos encantados de ayudarte a organizar, gestionar y disfrutar de tu colección de vinos.",
        "it": "Siamo felici di accompagnarti nella gestione e nella scoperta della tua collezione di vini.",
        "nl": "We helpen je graag om jouw wijncollectie te organiseren, beheren en volop te genieten van elke fles.",
        "pt": "Temos o prazer de o ajudar a organizar, gerir e desfrutar da sua coleção de vinhos."
    },

    "To get started, watch the short introduction video above and create your first cellar.": {
        "en": "To get started, watch the short introduction video above and create your first cellar.",
        "fr": "Pour bien démarrer, regardez la courte vidéo de présentation ci-dessus et créez votre première cave.",
        "de": "Sehen Sie sich zunächst das kurze Einführungsvideo an und legen Sie anschließend Ihren ersten Weinkeller an.",
        "es": "Para empezar, mira el breve vídeo de introducción y crea tu primera bodega.",
        "it": "Per iniziare, guarda il breve video introduttivo qui sopra e crea la tua prima cantina.",
        "nl": "Bekijk eerst de korte introductievideo hierboven en maak vervolgens je eerste wijnkelder aan.",
        "pt": "Para começar, veja o breve vídeo de apresentação acima e crie a sua primeira adega."
    },

    "In just a few minutes, you'll be ready to create units and add your wines, track your inventory and explore your collection.": {
        "en": "In just a few minutes, you'll be ready to create units, add your wines, track your inventory and explore your collection.",
        "fr": "En quelques minutes seulement, vous serez prêt à créer vos espaces de stockage, ajouter vos vins et explorer votre collection.",
        "de": "Schon nach wenigen Minuten können Sie Ihre Einheiten anlegen, Weine erfassen und Ihre Sammlung entdecken.",
        "es": "En solo unos minutos podrás crear tus unidades de almacenamiento, añadir tus vinos y explorar tu colección.",
        "it": "In pochi minuti potrai creare le tue unità di conservazione, aggiungere i tuoi vini ed esplorare la tua collezione.",
        "nl": "Binnen enkele minuten ben je klaar om units aan te maken, je wijnen toe te voegen en je collectie te verkennen.",
        "pt": "Em apenas alguns minutos, estará pronto para criar unidades, adicionar os seus vinhos, acompanhar o seu inventário e explorar a sua coleção."
    },

    "Enjoy your wine journey!": {
        "en": "Enjoy your wine journey!",
        "fr": "Nous vous souhaitons beaucoup de plaisir dans votre découverte du monde du vin !",
        "de": "Viel Freude auf Ihrer Reise durch die Welt des Weins!",
        "es": "¡Disfruta de tu viaje por el apasionante mundo del vino!",
        "it": "Buon viaggio alla scoperta del mondo del vino!",
        "nl": "Geniet van jouw ontdekkingstocht in de wereld van wijn!",
        "pt": "Desfrute da sua viagem pelo mundo do vinho!"
    },

    "The WyneLover Team": {
        "en": "The WyneLover Team",
        "fr": "L'équipe WyneLover",
        "de": "Das WyneLover-Team",
        "es": "El equipo de WyneLover",
        "it": "Il team di WyneLover",
        "nl": "Het WyneLover-team",
        "pt": "A equipa WyneLover"
    },

      "show this page again": {
        "en": "show this page again",
        "fr": "afficher cette page à nouveau",
        "de": "diese seite erneut anzeigen",
        "es": "mostrar esta página de nuevo",
        "it": "mostra di nuovo questa pagina",
        "nl": "deze pagina opnieuw tonen",
        "pt": "mostrar esta página novamente"
    },

    // Menu

    "cellar": {
        "en": "cellar",
        "fr": "cave",
        "de": "keller",
        "es": "bodega",
        "it": "cantina",
        "nl": "kelder",
        "pt": "adega"
    },

    "content": {
        "en": "content",
        "fr": "contenu",
        "de": "inhalt",
        "es": "contenido",
        "it": "contenuto",
        "nl": "inhoud",
        "pt": "conteúdo"
    },

    "search": {
    "en": "search",
    "fr": "rechercher",
    "de": "suche",
    "es": "buscar",
    "it": "cerca",
    "nl": "zoeken",
    "pt": "buscar"
    },

    "library": {
        "en": "library",
        "fr": "bibliothèque",
        "de": "bibliothek",
        "es": "biblioteca",
        "it": "libreria",
        "nl": "bibliotheek",
        "pt": "biblioteca"
    },
    "wishlist": {
        "en": "wishlist",
        "fr": "liste de souhaits",
        "de": "wunschliste",
        "es": "lista de deseos",
        "it": "lista dei desideri",
        "nl": "verlanglijst",
        "pt": "lista de desejos"
    },
    "archive": {
        "en": "archive",
        "fr": "archive",
        "de": "archiv",
        "es": "archivo",
        "it": "archivio",
        "nl": "archief",
        "pt": "arquivo"
    },
    "tools": {
        "en": "tools",
        "fr": "outils",
        "de": "werkzeuge",
        "es": "herramientas",
        "it": "strumenti",
        "nl": "hulpmiddelen",
        "pt": "ferramentas"
    },
    "about us": {
        "en": "about us",
        "fr": "à propos de nous",
        "de": "über uns",
        "es": "sobre nosotros",
        "it": "chi siamo",
        "nl": "over ons",
        "pt": "sobre nós"
    },
    "log off": {
        "en": "log off",
        "fr": "se déconnecter",
        "de": "abmelden",
        "es": "cerrar sesión",
        "it": "disconnettersi",
        "nl": "afmelden",
        "pt": "terminar sessão"
    },

    // Register and Profile pages

    "personal information": {
        "en": "personal information",
        "fr": "informations personnelles",
        "de": "persönliche Informationen",
        "es": "información personal",
        "it": "informazioni personali",
        "pt": "informações pessoais",
        "nl": "persoonlijke informatie"
    },

    "first name": {
        "en": "first name",
        "fr": "prénom",
        "de": "Vorname",
        "es": "nombre",
        "it": "nome",
        "pt": "primeiro nome",
        "nl": "voornaam"
    },

    "last name": {
        "en": "last name",
        "fr": "nom de famille",
        "de": "Nachname",
        "es": "apellido",
        "it": "cognome",
        "pt": "apelido",
        "nl": "achternaam"
    },

    "gender": {
        "en": "gender",
        "fr": "genre",
        "de": "Geschlecht",
        "es": "género",
        "it": "genere",
        "pt": "gênero",
        "nl": "geslacht"
    },
    "male": {
        "en": "male",
        "fr": "homme",
        "de": "männlich",
        "es": "masculino",
        "it": "maschile",
        "nl": "man",
        "pt": "masculino"
    },
    "female": {
        "en": "female",
        "fr": "femme",
        "de": "weiblich",
        "es": "femenino",
        "it": "femminile",
        "nl": "vrouw",
        "pt": "feminino"
    },
    "non-binary": {
        "en": "non-binary",
        "fr": "non binaire",
        "de": "nicht-binär",
        "es": "no binario",
        "it": "non binario",
        "nl": "non-binair",
        "pt": "não binário"
    },

    "language": {
        "en": "language",
        "fr": "langue",
        "de": "Sprache",
        "es": "idioma",
        "it": "lingua",
        "pt": "idioma",
        "nl": "taal"
    },

    "date of birth": {
        "en": "date of birth",
        "fr": "date de naissance",
        "de": "Geburtsdatum",
        "es": "fecha de nacimiento",
        "it": "data di nascita",
        "pt": "data de nascimento",
        "nl": "geboortedatum"
    },

    "wyne information": {
        "en": "wyne information",
        "fr": "informations wynelover",
        "de": "wynelover-Informationen",
        "es": "información wynelover",
        "it": "informazioni wynelover",
        "pt": "informações do wynelover",
        "nl": "wynelover informatie"
    },

    "cellar name": {
        "en": "cellar name",
        "fr": "nom de la cave à vin",
        "de": "Name des Weinkellers",
        "es": "nombre de la cava",
        "it": "nome della cantina",
        "pt": "nome da adega",
        "nl": "naam van de kelder"
    },

    "account information": {
        "en": "account information",
        "fr": "informations du compte",
        "de": "Kontoinformationen",
        "es": "información de la cuenta",
        "it": "informazioni sull'account",
        "pt": "informações da conta",
        "nl": "account informatie"
    },

    "confirm password": {
        "en": "confirm password",
        "fr": "confirmer le mot de passe",
        "de": "Passwort bestätigen",
        "es": "confirmar contraseña",
        "it": "conferma la password",
        "pt": "confirmar senha",
        "nl": "bevestig wachtwoord"
    },

    "This WyneLover account grants access to www.wynecellar.com and www.wynetaster.com.": {
        "en": "This WyneLover account grants access to www.wynecellar.com and www.wynetaster.com.",
        "fr": "Ce compte WyneLover permet d'accéder à www.wynecellar.com et www.wynetaster.com.",
        "de": "Dieses WyneLover-Konto gewährt Zugriff auf www.wynecellar.com und www.wynetaster.com.",
        "es": "Esta cuenta de WyneLover otorga acceso a www.wynecellar.com y www.wynetaster.com.",
        "it": "Questo account WyneLover garantisce l'accesso a www.wynecellar.com e www.wynetaster.com.",
        "pt": "Esta conta WyneLover concede acesso a www.wynecellar.com e www.wynetaster.com.",
        "nl": "Met dit WyneLover-account krijg je toegang tot www.wynecellar.com en www.wynetaster.com."
    },

    "I agree to": {
        "en": "I agree to",
        "fr": "J'accepte",
        "de": "Ich stimme den",
        "es": "Acepto",
        "it": "Accetto",
        "pt": "Eu concordo com",
        "nl": "Ik ga akkoord met"
    },

    "WyneLover Terms of Use and Privacy Policy.": {
        "en": "WyneLover Terms of Use and Privacy Policy.",
        "fr": "les conditions d'utilisation et Politique de confidentialité de WyneLover.",
        "de": "WyneLover Nutzungsbedingungen und Datenschutzrichtlinie.",
        "es": "los términos de uso y Política de privacidad de WyneLover.",
        "it": "i termini di utilizzo e Politica sulla privacy di WyneLover.",
        "pt": "os Termos de Uso e a Política de Privacidade da WyneLover.",
        "nl": "de Gebruiksvoorwaarden en het Privacybeleid van WyneLover."
    },

    "I want to change my password.": {
        "en": "I want to change my password.",
        "fr": "Je veux changer mon mot de passe.",
        "de": "Ich möchte mein Passwort ändern.",
        "es": "Quiero cambiar mi contraseña.",
        "it": "Voglio cambiare la mia password.",
        "pt": "Quero mudar minha senha.",
        "nl": "Ik wil mijn wachtwoord wijzigen."
    },

    "old password": {
        "en": "old password",
        "fr": "ancien mot de passe",
        "de": "altes Passwort",
        "es": "contraseña antigua",
        "it": "vecchia password",
        "pt": "senha antiga",
        "nl": "oud wachtwoord"
    },

    "new password": {
        "en": "new password",
        "fr": "nouveau mot de passe",
        "de": "neues Passwort",
        "es": "nueva contraseña",
        "it": "nuova password",
        "pt": "nova senha",
        "nl": "nieuw wachtwoord"
    },

    "confirm new password": {
        "en": "confirm new password",
        "fr": "confirmer le nouveau mot de passe",
        "de": "neues Passwort bestätigen",
        "es": "confirmar nueva contraseña",
        "it": "conferma la nuova password",
        "pt": "confirmar nova senha",
        "nl": "bevestig nieuw wachtwoord"
    },

    "update": {
        "en": "update",
        "fr": "mettre à jour",
        "de": "aktualisieren",
        "es": "actualizar",
        "it": "aggiornare",
        "pt": "atualizar",
        "nl": "bijwerken"
    },

    // Dashboard page 

    "dashboard": {
        "en": "dashboard",
        "fr": "tableau de bord",
        "de": "dashboard",
        "es": "panel de control",
        "it": "dashboard",
        "nl": "dashboard",
        "pt": "painel de controlo"
    },

    "number of bottles in cellar": {
        "en": "number of bottles in cellar",
        "fr": "nombre de bouteilles dans la cave",
        "de": "anzahl der Flaschen im Keller",
        "es": "número de botellas en la bodega",
        "it": "numero di bottiglie in cantina",
        "nl": "aantal flessen in de kelder",
        "pt": "número de garrafas na adega"
    },
    
    "Red": {
        "en": "Red",
        "fr": "Rouge",
        "de": "Rot",
        "es": "Tinto",
        "it": "Rosso",
        "nl": "Rood",
        "pt": "Tinto"
    },

    "White": {
        "en": "White",
        "fr": "Blanc",
        "de": "Weiß",
        "es": "Blanco",
        "it": "Bianco",
        "nl": "Wit",
        "pt": "Branco"
    },

    "Rosé": {
        "en": "Rosé",
        "fr": "Rosé",
        "de": "Rosé",
        "es": "Rosado",
        "it": "Rosato",
        "nl": "Rosé",
        "pt": "Rosé"
    },

    "countries": {
        "en": "countries",
        "fr": "pays",
        "de": "länder",
        "es": "países",
        "it": "paesi",
        "nl": "landen",
        "pt": "países"
    },

    "country": {
        "en": "country",
        "fr": "pays",
        "de": "land",
        "es": "país",
        "it": "paese",
        "nl": "land",
        "pt": "país"
    },

    "vintages": {
        "en": "vintages",
        "fr": "millésimes",
        "de": "jahrgänge",
        "es": "añadas",
        "it": "annate",
        "nl": "jaargangen",
        "pt": "safras"
    },

    "recent transactions": {
        "en": "recent transactions",
        "fr": "transactions récentes",
        "de": "kürzliche transaktionen",
        "es": "transacciones recientes",
        "it": "transazioni recenti",
        "nl": "recente transacties",
        "pt": "transações recentes"
    },

    "vintage": {
        "en": "vintage",
        "fr": "millésime",
        "de": "jahrgang",
        "es": "añada",
        "it": "annata",
        "nl": "jaargang",
        "pt": "safra"
    },

    "date": {
        "en": "date",
        "fr": "date",
        "de": "datum",
        "es": "fecha",
        "it": "data",
        "nl": "datum",
        "pt": "data"
    },

    "wine": {
        "en": "wine",
        "fr": "vin",
        "de": "wein",
        "es": "vino",
        "it": "vino",
        "nl": "wijn",
        "pt": "vinho"
    },

    "description": {
        "en": "description",
        "fr": "description",
        "de": "beschreibung",
        "es": "descripción",
        "it": "descrizione",
        "nl": "beschrijving",
        "pt": "descrição"
    },

    "price": {
        "en": "price",
        "fr": "prix",
        "de": "preis",
        "es": "precio",
        "it": "prezzo",
        "nl": "prijs",
        "pt": "preço"
    },

    // Cellar page 

    "overview of all units in": {
        "en": "overview of all units in",
        "fr": "aperçu de toutes les unités dans",
        "de": "übersicht aller einheiten in",
        "es": "vista general de todas las unidades en",
        "it": "panoramica di tutte le unità in",
        "nl": "overzicht van alle eenheden in",
        "pt": "visão geral de todas as unidades em"
    },

    "to select one, click - to add one, click on the plus sign": {
        "en": "to select one, click – to add one, click on the plus sign",
        "fr": "pour en sélectionner une, cliquez – pour en ajouter une, cliquez sur le signe plus",
        "de": "zum auswählen klicken – zum hinzufügen auf das pluszeichen klicken",
        "es": "para seleccionar una, haz clic – para añadir una, haz clic en el signo más",
        "it": "per selezionarne una, clicca – per aggiungerne una, clicca sul segno più",
        "nl": "klik om te selecteren – klik op het plusteken om toe te voegen",
        "pt": "para selecionar, clique – para adicionar, clique no sinal de mais"
    },

    // Niche page 

    "overview of": {
        "en": "overview of",
        "fr": "aperçu de",
        "de": "übersicht von",
        "es": "vista general",
        "it": "panoramica di",
        "nl": "overzicht van",
        "pt": "visão geral de"
    },

    "which has": {
        "en": "which has",
        "fr": "contenant",
        "de": "mit",
        "es": "con",
        "it": "con",
        "nl": "met",
        "pt": "com"
    },
    
    "bottles": {
        "en": "bottles",
        "fr": "bouteilles",
        "de": "Flaschen",
        "es": "botellas",
        "it": "bottiglie",
        "nl": "flessen",
        "pt": "garrafas"
    },

    // Search page

    "searching": {
        "en": "searching",
        "fr": "recherche en cours",
        "de": "suche läuft",
        "es": "buscando",
        "it": "ricerca in corso",
        "nl": "zoeken",
        "pt": "a pesquisar"
    },

    "search failed. please try again.": {
        "en": "search failed. please try again.",
        "fr": "la recherche a échoué. veuillez réessayer.",
        "de": "die suche ist fehlgeschlagen. bitte versuchen sie es erneut.",
        "es": "la búsqueda ha fallado. inténtelo de nuevo.",
        "it": "la ricerca non è riuscita. riprova.",
        "nl": "de zoekopdracht is mislukt. probeer opnieuw.",
        "pt": "a pesquisa falhou. tente novamente."
    },

    "loading cellar entries": {
        "en": "loading cellar entries...",
        "fr": "chargement des bouteilles de la cave...",
        "de": "kellereinträge werden geladen...",
        "es": "cargando las botellas de la bodega...",
        "it": "caricamento delle bottiglie della cantina...",
        "nl": "flessen uit de kelder worden geladen...",
        "pt": "a carregar as garrafas da adega..."
    },

    "search bottles in": {
        "en": "search bottles in",
        "fr": "rechercher des bouteilles dans",
        "de": "flaschen suchen",
        "es": "buscar botellas en",
        "it": "cerca bottiglie nella",
        "pt": "procurar garrafas na",
        "nl": "flessen zoeken in"
    },

    "name of winery or wine": {
        "en": "name of winery or wine",
        "fr": "nom du domaine ou du vin",
        "de": "Name des Weinguts oder Weins",
        "es": "nombre de la bodega o del vino",
        "it": "nome della cantina o del vino",
        "pt": "nome da vinícola ou do vinho",
        "nl": "naam van het wijnhuis of de wijn"
    },

    "vintage": {
        "en": "vintage",
        "fr": "millésime",
        "de": "Jahrgang",
        "es": "añada",
        "it": "annata",
        "pt": "safra",
        "nl": "jaargang"
    },

    "country or region": {
        "en": "country or region",
        "fr": "pays ou région",
        "de": "Land oder Region",
        "es": "país o región",
        "it": "paese o regione",
        "pt": "país ou região",
        "nl": "land of regio"
    },

    "appellation": {
        "en": "appellation",
        "fr": "appellation",
        "de": "Appellation",
        "es": "denominación",
        "it": "denominazione",
        "pt": "denominação",
        "nl": "appellatie"
    },

    "grapes": {
        "en": "grapes",
        "fr": "cépages",
        "de": "Rebsorten",
        "es": "variedades",
        "it": "vitigni",
        "pt": "castas",
        "nl": "druivensoorten"
    },

    "bottles": {
        "en": "bottles",
        "fr": "bouteilles",
        "de": "flaschen",
        "es": "botellas",
        "it": "bottiglie",
        "pt": "garrafas",
        "nl": "flessen"
    },

    "this query has": {
        "en": "this query has",
        "fr": "cette recherche a donné",
        "de": "diese suche ergab",
        "es": "esta búsqueda arrojó",
        "it": "questa ricerca ha prodotto",
        "pt": "esta pesquisa retornou",
        "nl": "deze zoekopdracht leverde"
    },

    "hits": {
        "en": "hits",
        "fr": "résultats",
        "de": "treffer",
        "es": "resultados",
        "it": "risultati",
        "pt": "resultados",
        "nl": "resultaten "
    },

    "page": {
        "en": "page",
        "fr": "page",
        "de": "seite",
        "es": "página",
        "it": "pagina",
        "pt": "página",
        "nl": "pagina"
    },

    "search": {
        "en": "search",
        "fr": "recherche",
        "de": "Suche",
        "es": "búsqueda",
        "it": "ricerca",
        "pt": "pesquisar",
        "nl": "zoeken"
    },

    "ok": {
        "en": "okay",
        "fr": "d'accord",
        "de": "einverstanden",
        "es": "de acuerdo",
        "it": "va bene",
        "nl": "oké",
        "pt": "certo"
    },

    "add entry": {
        "en": "add entry",
        "fr": "ajouter une entrée",
        "de": "Eintrag hinzufügen",
        "es": "añadir entrada",
        "it": "aggiungi voce",
        "nl": "invoer toevoegen",
        "pt": "adicionar entrada"
    },

    "archive entry": {
        "en": "archive entry",
        "fr": "archiver l'entrée",
        "de": "Eintrag archivieren",
        "es": "archivar entrada",
        "it": "archiviare voce",
        "nl": "invoer archiveren",
        "pt": "arquivar entrada"
    },

    "delete entry": {
        "en": "delete entry",
        "fr": "supprimer l'entrée",
        "de": "Eintrag löschen",
        "es": "eliminar entrada",
        "it": "eliminare voce",
        "nl": "invoer verwijderen",
        "pt": "excluir entrada"
    },

    "edit entry": {
        "en": "edit entry",
        "fr": "modifier l'entrée",
        "de": "Eintrag bearbeiten",
        "es": "editar entrada",
        "it": "modificare voce",
        "nl": "invoer bewerken",
        "pt": "editar entrada"
    },
    
    "edit": {
        "en": "edit",
        "fr": "modifier",
        "de": "bearbeiten",
        "es": "editar",
        "it": "modificare",
        "nl": "bewerken",
        "pt": "editar"
    },

    "ARE YOU SURE YOU WANT TO ARCHIVE THIS ENTRY?": {
        "en": "ARE YOU SURE YOU WANT TO ARCHIVE THIS ENTRY?",
        "fr": "ÊTES-VOUS SÛR DE VOULOIR ARCHIVER CETTE ENTRÉE ?",
        "de": "SIND SIE SICHER, DASS SIE DIESEN EINTRAG ARCHIVIEREN MÖCHTEN?",
        "es": "¿ESTÁS SEGURO DE QUE QUIERES ARCHIVAR ESTA ENTRADA?",
        "it": "SEI SICURO DI VOLER ARCHIVIARE QUESTA VOCE?",
        "nl": "WEET U ZEKER DAT U DEZE INVOER WILT ARCHIVEREN?",
        "pt": "TEM CERTEZA DE QUE DESEJA ARQUIVAR ESTA ENTRADA?"
    },

    "ARE YOU SURE YOU WANT TO DELETE THIS ENTRY?": {
        "en": "ARE YOU SURE YOU WANT TO DELETE THIS ENTRY?",
        "fr": "ÊTES-VOUS SÛR DE VOULOIR SUPPRIMER CETTE ENTRÉE ?",
        "de": "SIND SIE SICHER, DASS SIE DIESEN EINTRAG LÖSCHEN MÖCHTEN?",
        "es": "¿ESTÁS SEGURO DE QUE QUIERES ELIMINAR ESTA ENTRADA?",
        "it": "SEI SICURO DI VOLER ELIMINARE QUESTA VOCE?",
        "nl": "WEET U ZEKER DAT U DEZE INVOER WILT VERWIJDEREN?",
        "pt": "TEM CERTEZA DE QUE DESEJA EXCLUIR ESTA ENTRADA?"
    },

    "ARE YOU SURE YOU WANT TO DELETE THIS TRANSACTION?": {
        "en": "ARE YOU SURE YOU WANT TO DELETE THIS TRANSACTION?",
        "fr": "ÊTES-VOUS SÛR DE VOULOIR SUPPRIMER CETTE TRANSACTION ?",
        "de": "SIND SIE SICHER, DASS SIE DIESE TRANSAKTION LÖSCHEN MÖCHTEN?",
        "es": "¿ESTÁS SEGURO DE QUE QUIERES ELIMINAR ESTA TRANSACCIÓN?",
        "it": "SEI SICURO DI VOLER ELIMINARE QUESTA TRANSAZIONE?",
        "nl": "WEET U ZEKER DAT U DEZE TRANSACTIE WILT VERWIJDEREN?",
        "pt": "TEM CERTEZA DE QUE DESEJA EXCLUIR ESTA TRANSAÇÃO?"
    },

    // Library page
    "library": {
        "en": "library",
        "fr": "bibliothèque",
        "de": "bibliothek",
        "es": "biblioteca",
        "it": "libreria",
        "pt": "biblioteca",
        "nl": "bibliotheek"
    },

    "search wine in database": {
        "en": "search wine in database",
        "fr": "rechercher un vin dans la base de données",
        "de": "wein in der Datenbank suchen",
        "es": "buscar vino en la base de datos",
        "it": "cerca vino nel database",
        "pt": "procurar vinho na base de dados",
        "nl": "wijn zoeken in de database"
    },

    // Wishlist page

    "wishlist of bottles you want to buy": {
        "en": "wishlist of bottles you want to buy",
        "fr": "liste de souhaits de bouteilles que vous souhaitez acheter",
        "de": "wunschliste mit flaschen, die du kaufen möchtest",
        "es": "lista de deseos de botellas que quieres comprar",
        "it": "lista dei desideri di bottiglie che vuoi acquistare",
        "pt": "lista de desejos de garrafas que você quer comprar",
        "nl": "verlanglijst van flessen die je wilt kopen"
    },

    "edit bottle": {
        "en": "edit bottle",
        "fr": "modifier la bouteille",
        "de": "Flasche bearbeiten",
        "es": "editar botella",
        "it": "modifica bottiglia",
        "pt": "editar garrafa",
        "nl": "fles bewerken"
    },

    "show bottle": {
        "en": "show bottle",
        "fr": "montrer la bouteille",
        "de": "flasche anzeigen",
        "es": "mostrar botella",
        "it": "mostra bottiglia",
        "nl": "fles tonen",
        "pt": "mostrar garrafa"
    },

    "new bottle": {
        "en": "new bottle",
        "fr": "nouvelle bouteille",
        "de": "neue Flasche",
        "es": "nueva botella",
        "it": "nuova bottiglia",
        "pt": "nova garrafa",
        "nl": "nieuwe fles"
    },

    "from database": {
        "en": "from database",
        "fr": "depuis la base de données",
        "de": "aus der Datenbank",
        "es": "desde la base de datos",
        "it": "dal database",
        "pt": "da base de dados",
        "nl": "uit de databank"
    },

    "add manually": {
        "en": "add manually",
        "fr": "ajouter manuellement",
        "de": "manuell hinzufügen",
        "es": "añadir manualmente",
        "it": "aggiungi manualmente",
        "pt": "adicionar manualmente",
        "nl": "handmatig toevoegen"
    },

    "delete bottle from wishlist": {
        "en": "delete bottle from wishlist",
        "fr": "supprimer la bouteille de la liste de souhaits",
        "de": "Flasche von der Wunschliste löschen",
        "es": "eliminar la botella de la lista de deseos",
        "it": "elimina la bottiglia dalla lista dei desideri",
        "nl": "verwijder fles uit verlanglijst",
        "pt": "excluir a garrafa da lista de desejos"
    },

    "ARE YOU SURE YOU WANT TO DELETE THIS BOTTLE FROM YOUR WISHLIST?": {
        "en": "ARE YOU SURE YOU WANT TO DELETE THIS BOTTLE FROM YOUR WISHLIST?",
        "fr": "ÊTES-VOUS SÛR DE VOULOIR SUPPRIMER CETTE BOUTEILLE DE VOTRE LISTE DE SOUHAITS ?",
        "de": "SIND SIE SICHER, DASS SIE DIESE FLASCHE AUS IHRER WUNSCHLISTE LÖSCHEN MÖCHTEN?",
        "es": "¿ESTÁ SEGURO DE QUE QUIERE ELIMINAR ESTA BOTELLA DE SU LISTA DE DESEOS?",
        "it": "SEI SICURO DI VOLER ELIMINARE QUESTA BOTTIGLIA DALLA TUA LISTA DEI DESIDERI?",
        "nl": "WEET U ZEKER DAT U DEZE FLES VAN UW VERLANGLIJST WILT VERWIJDEREN?",
        "pt": "TEM CERTEZA DE QUE DESEJA EXCLUIR ESTA GARRAFA DA SUA LISTA DE DESEJOS?"
    },

    "remove from wishlist": {
        "en": "remove from wishlist",
        "fr": "retirer de la liste de souhaits",
        "de": "von der Wunschliste entfernen",
        "es": "eliminar de la lista de deseos",
        "it": "rimuovi dalla lista dei desideri",
        "pt": "remover da lista de desejos",
        "nl": "verwijderen uit verlanglijst"
    },


    // --> FullDefine page

    "wine": {
        "en": "wine",
        "fr": "vin",
        "de": "wein",
        "es": "vino",
        "it": "vino",
        "pt": "vinho",
        "nl": "wijn"
    },
    "purchase": {
        "en": "purchase",
        "fr": "achat",
        "de": "Kauf",
        "es": "compra",
        "it": "acquisto",
        "pt": "compra",
        "nl": "aankoop"
    },
    "detail": {
        "en": "detail",
        "fr": "détail",
        "de": "Detail",
        "es": "detalle",
        "it": "dettaglio",
        "pt": "detalhe",
        "nl": "detail"
    },
    "pictures": {
        "en": "pictures",
        "fr": "photos",
        "de": "Bilder",
        "es": "fotos",
        "it": "foto",
        "pt": "fotos",
        "nl": "foto's"
    },

    "winery name": {
        "en": "winery name",
        "fr": "nom du domaine",
        "de": "Name des Weinguts",
        "es": "nombre de la bodega",
        "it": "nome della cantina",
        "pt": "nome da vinícola",
        "nl": "naam van het wijnhuis"
    },

    "page": {
        "en": "page",
        "fr": "page",
        "de": "Seite",
        "es": "página",
        "it": "pagina",
        "pt": "página",
        "nl": "pagina"
    },

    "wine name": {
        "en": "wine name",
        "fr": "nom du vin",
        "de": "Name des Weins",
        "es": "nombre del vino",
        "it": "nome del vino",
        "pt": "nome do vinho",
        "nl": "naam van de wijn"
    },

    "country - free format": {
        "en": "country - free format",
        "fr": "pays - format libre",
        "de": "Land – Freitext",
        "es": "país - formato libre",
        "it": "paese - formato libero",
        "pt": "país - formato livre",
        "nl": "land - vrije invoer"
    },

    "region": {
        "en": "region",
        "fr": "région",
        "de": "Region",
        "es": "región",
        "it": "regione",
        "pt": "região",
        "nl": "regio"
    },

    "region - free format": {
        "en": "region - free format",
        "fr": "région - format libre",
        "de": "Region – Freitext",
        "es": "región - formato libre",
        "it": "regione - formato libero",
        "pt": "região - formato livre",
        "nl": "regio - vrije invoer"
    },

    "appellation": {
        "en": "appellation",
        "fr": "appellation",
        "de": "Appellation",
        "es": "denominación",
        "it": "denominazione",
        "pt": "denominação",
        "nl": "herkomstbenaming"
    },

    "appellation - free format": {
        "en": "appellation - free format",
        "fr": "appellation - format libre",
        "de": "Appellation – Freitext",
        "es": "denominación - formato libre",
        "it": "denominazione - formato libero",
        "pt": "denominação - formato livre",
        "nl": "herkomstbenaming - vrije invoer"
    },

    "classification": {
        "en": "classification",
        "fr": "classification",
        "de": "Klassifikation",
        "es": "clasificación",
        "it": "classificazione",
        "pt": "classificação",
        "nl": "classificatie"
    },

    "classification - free format": {
        "en": "classification - free format",
        "fr": "classification - format libre",
        "de": "Klassifikation – Freitext",
        "es": "clasificación - formato libre",
        "it": "classificazione - formato libero",
        "pt": "classificação - formato livre",
        "nl": "classificatie - vrije invoer"
    },

    "color": {
        "en": "color",
        "fr": "couleur",
        "de": "Farbe",
        "es": "color",
        "it": "colore",
        "pt": "cor",
        "nl": "kleur"
    },

    "sparkling": {
        "en": "sparkling",
        "fr": "effervescent",
        "de": "schaumwein",
        "es": "espumoso",
        "it": "spumante",
        "pt": "espumante",
        "nl": "mousserend"
    },

    "sweet": {
        "en": "sweet",
        "fr": "doux",
        "de": "süß",
        "es": "dulce",
        "it": "dolce",
        "pt": "doce",
        "nl": "zoet"
    },

    "occasion": {
        "en": "occasion",
        "fr": "occasion",
        "de": "Anlass",
        "es": "ocasión",
        "it": "occasione",
        "pt": "ocasião",
        "nl": "gelegenheid"
    },
    "number": {
        "en": "number",
        "fr": "quantité",
        "de": "Anzahl",
        "es": "cantidad",
        "it": "quantità",
        "pt": "quantidade",
        "nl": "aantal"
    },
    "date": {
        "en": "date",
        "fr": "date",
        "de": "Datum",
        "es": "fecha",
        "it": "data",
        "pt": "data",
        "nl": "datum"
    },
    "price": {
        "en": "price",
        "fr": "prix",
        "de": "Preis",
        "es": "precio",
        "it": "prezzo",
        "pt": "preço",
        "nl": "prijs"
    },

    "grapes": {
        "en": "grapes",
        "fr": "cépages",
        "de": "Rebsorten",
        "es": "variedades",
        "it": "vitigni",
        "pt": "castas",
        "nl": "druiven"
    },
    "longevity": {
        "en": "longevity",
        "fr": "potentiel de garde",
        "de": "Lagerfähigkeit",
        "es": "longevidad",
        "it": "longevità",
        "pt": "longevidade",
        "nl": "bewaarpotentieel"
    },
    "vines": {
        "en": "vines",
        "fr": "vignes",
        "de": "Reben",
        "es": "viñas",
        "it": "viti",
        "pt": "videiras",
        "nl": "wijnstokken"
    },
    "yields": {
        "en": "yields",
        "fr": "rendements",
        "de": "Erträge",
        "es": "rendimientos",
        "it": "rese",
        "pt": "rendimentos",
        "nl": "opbrengsten"
    },
    "vinification": {
        "en": "vinification",
        "fr": "vinification",
        "de": "Vinifikation",
        "es": "vinificación",
        "it": "vinificazione",
        "pt": "vinificação",
        "nl": "vinificatie"
    },
    "aging": {
        "en": "aging",
        "fr": "élevage",
        "de": "Ausbau",
        "es": "crianza",
        "it": "affinamento",
        "pt": "envelhecimento",
        "nl": "rijping"
    },
    "alcohol": {
        "en": "alcohol",
        "fr": "alcool",
        "de": "Alkohol",
        "es": "alcohol",
        "it": "alcol",
        "pt": "álcool",
        "nl": "alcohol"
    },

    // Archive page

    "overview of bottles you once had": {
        "en": "overview of bottles you once had",
        "fr": "aperçu des bouteilles que vous avez eues",
        "de": "übersicht der flaschen, die du einmal hattest",
        "es": "vista general de las botellas que una vez tuviste",
        "it": "panoramica delle bottiglie che avevi una volta",
        "pt": "visão geral das garrafas que você já teve",
        "nl": "overzicht van flessen die je ooit had"
    },

    "to select one, click": {
        "en": "to select one, click",
        "fr": "pour en sélectionner un, cliquez",
        "de": "zum auswählen klicken",
        "es": "para seleccionar uno, haz clic",
        "it": "per selezionarne uno, clicca",
        "pt": "para selecionar um, clique",
        "nl": "klik om te selecteren"
    },

    "archived": {
        "en": "archived",
        "fr": "archivé",
        "de": "archiviert",
        "es": "archivado",
        "it": "archiviato",
        "pt": "arquivado",
        "nl": "gearchiveerd"
    },

    "search archived wines": {
        "en": "search archived wines...",
        "fr": "rechercher des vins archivés...",
        "de": "archivierte weine suchen...",
        "es": "buscar vinos archivados...",
        "it": "cerca vini archiviati...",
        "nl": "zoek gearchiveerde wijnen...",
        "pt": "pesquisar vinhos arquivados..."
    },

    "showing": {
        "en": "showing",
        "fr": "affichage de",
        "de": "anzeige",
        "es": "mostrando",
        "it": "visualizzazione di",
        "nl": "weergave van",
        "pt": "mostrando"
    },

    "archived bottles": {
        "en": "archived bottles",
        "fr": "bouteilles archivées",
        "de": "archivierte flaschen",
        "es": "botellas archivadas",
        "it": "bottiglie archiviate",
        "nl": "gearchiveerde flessen",
        "pt": "garrafas arquivadas"
    },

    "deleting the entry is also deleting all transactions and tasting notes of the entry": {
        "en": "deleting the entry is also deleting all transactions and tasting notes of the entry",
        "fr": "la suppression de l'entrée supprime également toutes les transactions et les notes de dégustation de l'entrée",
        "de": "das Löschen des Eintrags löscht auch alle Transaktionen und Verkostungsnotizen des Eintrags",
        "es": "eliminar la entrada también elimina todas las transacciones y las notas de cata de la entrada",
        "it": "l'eliminazione della voce elimina anche tutte le transazioni e le note di degustazione della voce",
        "nl": "het verwijderen van de invoer verwijdert ook alle transacties en proefnotities van de invoer",
        "pt": "a exclusão da entrada também exclui todas as transações e notas de degustação da entrada"
    },

    // Paginator

    "show": {
        "en": "show",
        "fr": "afficher",
        "de": "zeige",
        "es": "mostrar",
        "it": "mostra",
        "nl": "toon",
        "pt": "mostrar"
    },

    "per page": {
        "en": "per page",
        "fr": "par page",
        "de": "pro seite",
        "es": "por página",
        "it": "per pagina",
        "nl": "per pagina",
        "pt": "por página"
    },

    "page": {
        "en": "page",
        "fr": "page",
        "de": "seite",
        "es": "página",
        "it": "pagina",
        "nl": "pagina",
        "pt": "página"
    },

    "of": {
        "en": "of",
        "fr": "sur",
        "de": "von",
        "es": "de",
        "it": "di",
        "nl": "van",
        "pt": "de"
    },

    // Tools page

    "extra tools for your cellar": {
        "en": "extra tools for your cellar",
        "fr": "outils supplémentaires pour votre cave",
        "de": "zusätzliche Werkzeuge für Ihren Weinkeller",
        "es": "herramientas adicionales para tu bodega",
        "it": "strumenti extra per la tua cantina",
        "nl": "extra hulpmiddelen voor je kelder",
        "pt": "ferramentas extras para a sua adega"
    },
    "download spreadsheet": {
        "en": "download spreadsheet",
        "fr": "télécharger la feuille de calcul",
        "de": "tabelle herunterladen",
        "es": "descargar hoja de cálculo",
        "it": "scarica foglio di calcolo",
        "nl": "spreadsheet downloaden",
        "pt": "baixar planilha"
    },
    "calculate value": {
        "en": "calculate value",
        "fr": "calculer la valeur",
        "de": "wert berechnen",
        "es": "calcular valor",
        "it": "calcola valore",
        "nl": "waarde berekenen",
        "pt": "calcular valor"
    },
    "check consistency": {
        "en": "check consistency",
        "fr": "vérifier la cohérence",
        "de": "konsistenz prüfen",
        "es": "verificar consistencia",
        "it": "controlla coerenza",
        "nl": "controleer consistentie",
        "pt": "verificar consistência"
    },
    "sync entries to wyne library": {
        "en": "sync entries to wyne library",
        "fr": "synchroniser les entrées avec la bibliothèque wyne",
        "de": "einträge mit der wyne-bibliothek synchronisieren",
        "es": "sincronizar entradas con la biblioteca wyne",
        "it": "sincronizza voci con la libreria wyne",
        "nl": "items synchroniseren met de wyne-bibliotheek",
        "pt": "sincronizar entradas com a biblioteca wyne"
    },

    "cellar value": {
        "en": "cellar value",
        "fr": "valeur de la cave",
        "de": "kellerwert",
        "es": "valor de la bodega",
        "it": "valore della cantina",
        "nl": "kelderwaarde",
        "pt": "valor da adega"
    },
    "Calculating the inventory value of a cellar is only possible if you have been consistent with your input of purchase transactions.": {
        "en": "Calculating the inventory value of a cellar is only possible if you have been consistent with your input of purchase transactions.",
        "fr": "Le calcul de la valeur d’inventaire d’une cave n’est possible que si vos saisies d’achats sont cohérentes.",
        "de": "Die Berechnung des Lagerwerts eines Kellers ist nur möglich, wenn Ihre Eingaben zu Kauftransaktionen konsistent sind.",
        "es": "Calcular el valor del inventario de una bodega solo es posible si tus registros de compras son coherentes.",
        "it": "Il calcolo del valore di inventario di una cantina è possibile solo se gli inserimenti degli acquisti sono coerenti.",
        "nl": "De inventariswaarde van een kelder berekenen kan alleen als je aankoopinvoer consistent is.",
        "pt": "Calcular o valor de inventário de uma adega só é possível se as entradas de compras forem consistentes."
    },
    "Here are examples of proper inputs:": {
        "en": "Here are examples of proper inputs:",
        "fr": "Voici des exemples de saisies correctes :",
        "de": "Hier sind Beispiele für korrekte Eingaben:",
        "es": "Aquí hay ejemplos de entradas correctas:",
        "it": "Ecco alcuni esempi di inserimenti corretti:",
        "nl": "Hier zijn voorbeelden van correcte invoer:",
        "pt": "Aqui estão exemplos de entradas corretas:"
    },
    "All purchase must be in the same currency and should be consistent in incl. or excl. VAT.": {
        "en": "All purchase must be in the same currency and should be consistent in incl. or excl. VAT.",
        "fr": "Tous les achats doivent être dans la même devise et cohérents quant à la TVA incluse ou exclue.",
        "de": "Alle Käufe müssen in derselben Währung sein und einheitlich inkl. oder exkl. MwSt. angegeben werden.",
        "es": "Todas las compras deben estar en la misma moneda y ser coherentes respecto a si incluyen o excluyen IVA.",
        "it": "Tutti gli acquisti devono essere nella stessa valuta ed essere coerenti riguardo IVA inclusa o esclusa.",
        "nl": "Alle aankopen moeten in dezelfde valuta zijn en consequent incl. of excl. btw.",
        "pt": "Todas as compras devem estar na mesma moeda e ser consistentes quanto a incluir ou excluir IVA."
    },
    "When VAT status is not mentioned it is considered to be incl.": {
        "en": "When VAT status is not mentioned it is considered to be incl.",
        "fr": "Si le statut de TVA n’est pas précisé, il est considéré comme inclus.",
        "de": "Wenn der MwSt-Status nicht angegeben ist, gilt er als inklusiv.",
        "es": "Si no se menciona el estado del IVA, se considera incluido.",
        "it": "Se lo stato IVA non è indicato, si considera incluso.",
        "nl": "Als de btw-status niet vermeld is, wordt deze als inclusief beschouwd.",
        "pt": "Quando o estado do IVA não é mencionado, considera-se incluído."
    },
    "Let us check ...": {
        "en": "Let us check ...",
        "fr": "Vérifions…",
        "de": "Lassen Sie uns prüfen …",
        "es": "Vamos comprobar…",
        "it": "Verifichiamo…",
        "nl": "Laten we het controleren…",
        "pt": "Vamos verificar…"
    },
    "checking cellar transaction consistency": {
        "en": "checking cellar transaction consistency",
        "fr": "vérification de la cohérence des transactions de cave",
        "de": "überprüfung der konsistenz der kellertransaktionen",
        "es": "comprobando la consistencia de las transacciones de la bodega",
        "it": "verifica della coerenza delle transazioni della cantina",
        "nl": "consistentie van keldertransacties controleren",
        "pt": "verificando a consistência das transações da adega"
    },
    "We have checked your cellar on consistency in purchase transaction price input.": {
        "en": "We have checked your cellar on consistency in purchase transaction price input.",
        "fr": "Nous avons vérifié la cohérence de la saisie des prix d’achat de votre cave.",
        "de": "Wir haben die Konsistenz Ihrer Kaufpreiseingaben im Keller überprüft.",
        "es": "Hemos verificado la coherencia en la entrada de precios de compra de tu bodega.",
        "it": "Abbiamo verificato la coerenza dell’inserimento dei prezzi di acquisto della tua cantina.",
        "nl": "We hebben je kelder gecontroleerd op consistentie in de invoer van aankoopprijzen.",
        "pt": "Verificámos a consistência da introdução de preços de compra da sua adega."
    },
    "You have used": {
        "en": "You have used",
        "fr": "Vous avez utilisé",
        "de": "Sie haben",
        "es": "Has utilizado",
        "it": "Hai usato",
        "nl": "Je hebt",
        "pt": "Você utilizou"
    },
    "currencies uniformly, which is perfect.": {
        "en": "currencies uniformly, which is perfect.",
        "fr": "devise(s) de manière uniforme, c’est parfait.",
        "de": "währung(en) einheitlich verwendet – perfekt.",
        "es": "moneda(s) de forma uniforme, lo cual es perfecto.",
        "it": "valuta/e in modo uniforme, il che è perfetto.",
        "nl": "valuta’s uniform gebruikt—perfect.",
        "pt": "moeda(s) de forma uniforme — perfeito."
    },
    "different currencies": {
        "en": "different currencies",
        "fr": "devises différentes",
        "de": "verschiedene währungen",
        "es": "monedas diferentes",
        "it": "valute diverse",
        "nl": "verschillende valuta’s",
        "pt": "moedas diferentes"
    },
    "blank": {
        "en": "blank",
        "fr": "vide",
        "de": "leer",
        "es": "en blanco",
        "it": "vuoto",
        "nl": "leeg",
        "pt": "em branco"
    },
    "in": {
        "en": "in",
        "fr": "dans",
        "de": "in",
        "es": "en",
        "it": "in",
        "nl": "in",
        "pt": "em"
    },
    "purchase transactions": {
        "en": "purchase transactions",
        "fr": "transactions d'achat",
        "de": "kauftransaktionen",
        "es": "transacciones de compra",
        "it": "transazioni di acquisto",
        "nl": "aankooptransacties",
        "pt": "transações de compra"
    },
    "transactions": {
        "en": "transactions",
        "fr": "transactions",
        "de": "transaktionen",
        "es": "transacciones",
        "it": "transazioni",
        "nl": "transacties",
        "pt": "transações"
    },
    "(click here to show)": {
        "en": "(click here to show)",
        "fr": "(cliquez ici pour afficher)",
        "de": "(hier klicken, um anzuzeigen)",
        "es": "(haz clic aquí para mostrar)",
        "it": "(clicca qui per mostrare)",
        "nl": "(klik hier om te tonen)",
        "pt": "(clique aqui para mostrar)"
    },
    "The entries with blank currency will be considered to use your main currency.": {
        "en": "The entries with blank currency will be considered to use your main currency.",
        "fr": "Les entrées avec devise vide seront considérées comme utilisant votre devise principale.",
        "de": "Einträge ohne Währung werden als in Ihrer Hauptwährung betrachtet.",
        "es": "Las entradas con moneda en blanco se considerarán en tu moneda principal.",
        "it": "Le voci con valuta vuota saranno considerate nella tua valuta principale.",
        "nl": "Items met een lege valuta worden beschouwd als je hoofdvaluta.",
        "pt": "As entradas com moeda em branco serão consideradas na sua moeda principal."
    },
    "VAT status": {
        "en": "VAT status",
        "fr": "statut TVA",
        "de": "mwst-status",
        "es": "estado del IVA",
        "it": "stato IVA",
        "nl": "btw-status",
        "pt": "estado do IVA"
    },
    "VAT status uniformly, which is perfect.": {
        "en": "VAT status uniformly, which is perfect.",
        "fr": "statut(s) de TVA de manière uniforme, ce qui est parfait.",
        "de": "mwst-status einheitlich — perfekt.",
        "es": "estado(s) de IVA de forma uniforme, lo cual es perfecto.",
        "it": "stato/i IVA in modo uniforme, il che è perfetto.",
        "nl": "btw-status(sen) uniform gebruikt—perfect.",
        "pt": "estado(s) de IVA de forma uniforme — perfeito."
    },
    "different VAT status": {
        "en": "different VAT status",
        "fr": "statuts de TVA différents",
        "de": "unterschiedliche mwst-status",
        "es": "estados de IVA diferentes",
        "it": "stati IVA diversi",
        "nl": "verschillende btw-statussen",
        "pt": "estados de IVA diferentes"
    },
    "The entries with blank VAT status will be considered to use your main VAT status.": {
        "en": "The entries with blank VAT status will be considered to use your main VAT status.",
        "fr": "Les entrées avec un statut TVA vide seront considérées comme utilisant votre statut TVA principal.",
        "de": "Einträge ohne MwSt-Status werden als Ihr Haupt-MwSt-Status gewertet.",
        "es": "Las entradas con estado de IVA en blanco se considerarán con tu estado de IVA principal.",
        "it": "Le voci con stato IVA vuoto saranno considerate con il tuo stato IVA principale.",
        "nl": "Items met een lege btw-status worden beschouwd als je hoofd-btw-status.",
        "pt": "As entradas com estado de IVA em branco serão consideradas com o seu estado de IVA principal."
    },
    "You have": {
        "en": "You have",
        "fr": "Vous avez",
        "de": "Sie haben",
        "es": "Tienes",
        "it": "Hai",
        "nl": "Je hebt",
        "pt": "Você tem"
    },
    "zero-priced or blank-priced purchase transactions": {
        "en": "zero-priced or blank-priced purchase transactions",
        "fr": "transactions d’achat à prix nul ou vide",
        "de": "Kauftransaktionen mit Preis 0 oder leerem Preis",
        "es": "transacciones de compra con precio cero o en blanco",
        "it": "transazioni di acquisto a prezzo zero o vuoto",
        "nl": "aankooptransacties met een nulprijs of lege prijs",
        "pt": "transações de compra com preço zero ou em branco"
    },
    "The value of your cellar is:": {
        "en": "The value of your cellar is:",
        "fr": "La valeur de votre cave est :",
        "de": "Der Wert Ihres Kellers ist:",
        "es": "El valor de tu bodega es:",
        "it": "Il valore della tua cantina è:",
        "nl": "De waarde van je kelder is:",
        "pt": "O valor da sua adega é:"
    },
    "However, you have": {
        "en": "However, you have",
        "fr": "Cependant, vous avez",
        "de": "Allerdings haben Sie",
        "es": "Sin embargo, tienes",
        "it": "Tuttavia, hai",
        "nl": "Echter, je hebt",
        "pt": "No entanto, você tem"
    },
    "entries with conflicting purchase entries that might cause errors in your results.": {
        "en": "entries with conflicting purchase entries that might cause errors in your results.",
        "fr": "entrées avec des achats contradictoires pouvant fausser les résultats.",
        "de": "Einträge mit widersprüchlichen Kaufangaben, die Ihre Ergebnisse verfälschen können.",
        "es": "entradas con compras en conflicto que pueden causar errores en tus resultados.",
        "it": "voci con acquisti in conflitto che potrebbero causare errori nei risultati.",
        "nl": "items met conflicterende aankoopvermeldingen die je resultaten kunnen verstoren.",
        "pt": "entradas com compras conflitantes que podem causar erros nos resultados."
    },
    "Please correct the issues described above and try again.": {
        "en": "Please correct the issues described above and try again.",
        "fr": "Veuillez corriger les problèmes décrits ci-dessus et réessayer.",
        "de": "Bitte beheben Sie die oben beschriebenen Probleme und versuchen Sie es erneut.",
        "es": "Corrige los problemas descritos arriba y vuelve a intentarlo.",
        "it": "Correggi i problemi descritti sopra e riprova.",
        "nl": "Corrigeer de bovenstaande problemen en probeer het opnieuw.",
        "pt": "Corrija os problemas descritos acima e tente novamente."
    },
    "cancel": {
        "en": "cancel",
        "fr": "annuler",
        "de": "abbrechen",
        "es": "cancelar",
        "it": "annulla",
        "nl": "annuleren",
        "pt": "cancelar"
    },
    "close": {
        "en": "close",
        "fr": "fermer",
        "de": "schließen",
        "es": "cerrar",
        "it": "chiudi",
        "nl": "sluiten",
        "pt": "fechar"
    },
    "check cellar consistency": {
        "en": "check cellar consistency",
        "fr": "vérifier la cohérence de la cave",
        "de": "kellerkonsistenz prüfen",
        "es": "comprobar la consistencia de la bodega",
        "it": "verifica della coerenza della cantina",
        "nl": "kelderconsistentie controleren",
        "pt": "verificar a consistência da adega"
    },
    "This cellar has": {
        "en": "This cellar has",
        "fr": "Cette cave contient",
        "de": "Dieser Keller hat",
        "es": "Esta bodega tiene",
        "it": "Questa cantina ha",
        "nl": "Deze kelder heeft",
        "pt": "Esta adega tem"
    },
    "entries": {
        "en": "entries",
        "fr": "entrées",
        "de": "einträge",
        "es": "entradas",
        "it": "voci",
        "nl": "items",
        "pt": "entradas"
    },
    "The units of this cellar contain": {
        "en": "The units of this cellar contain",
        "fr": "Les unités de cette cave contiennent",
        "de": "Die einheiten dieses kellers enthalten",
        "es": "Las unidades de esta bodega contienen",
        "it": "Le unità di questa cantina contengono",
        "nl": "De eenheden van deze kelder bevatten",
        "pt": "As unidades desta adega contêm"
    },
    "Entries found in cellar, not found in niche": {
        "en": "Entries found in cellar, not found in niche",
        "fr": "Entrées trouvées dans la cave, non trouvées dans la niche",
        "de": "Einträge im Keller gefunden, nicht in der Nische",
        "es": "Entradas encontradas en la bodega, no en la nicho",
        "it": "Voci trovate in cantina, non nella nicchia",
        "nl": "Items gevonden in kelder, niet in nis",
        "pt": "Entradas encontradas na adega, não no nicho"
    },
    "repair this entry": {
        "en": "repair this entry",
        "fr": "réparer cette entrée",
        "de": "diesen eintrag reparieren",
        "es": "reparar esta entrada",
        "it": "ripara questa voce",
        "nl": "dit item herstellen",
        "pt": "corrigir esta entrada"
    },
    "archive this entry": {
        "en": "archive this entry",
        "fr": "archiver cette entrée",
        "de": "diesen eintrag archivieren",
        "es": "archivar esta entrada",
        "it": "archivia questa voce",
        "nl": "dit item archiveren",
        "pt": "arquivar esta entrada"
    },
    "Entries found in niche, not found in cellar": {
        "en": "Entries found in niche, not found in cellar",
        "fr": "Entrées trouvées dans la niche, non trouvées dans la cave",
        "de": "Einträge in der Nische gefunden, nicht im Keller",
        "es": "Entradas encontradas en la nicho, no en la bodega",
        "it": "Voci trovate nella nicchia, non in cantina",
        "nl": "Items gevonden in nis, niet in kelder",
        "pt": "Entradas encontradas no nicho, não na adega"
    },
    "in development": {
        "en": "in development",
        "fr": "en développement",
        "de": "in entwicklung",
        "es": "en desarrollo",
        "it": "in sviluppo",
        "nl": "in ontwikkeling",
        "pt": "em desenvolvimento"
    },

    // WineShow page

    "add to unit": {
        "en": "add to unit",
        "fr": "ajouter à une unité",
        "de": "zu einheit hinzufügen",
        "es": "añadir a la unidad",
        "it": "aggiungi all'unità",
        "nl": "toevoegen aan eenheid",
        "pt": "adicionar à unidade"
    },

    "add wine to ...": {
        "en": "add wine to ...",
        "fr": "ajouter du vin à ...",
        "de": "wein hinzufügen zu ...",
        "es": "añadir vino a ...",
        "it": "aggiungi vino a ...",
        "nl": "wijn toevoegen aan ...",
        "pt": "adicionar vinho a ..."
    },

    "add wine to wishlist": {
        "en": "add wine to wishlist",
        "fr": "ajouter du vin à la liste de souhaits",
        "de": "wein zur wunschliste hinzufügen",
        "es": "añadir vino a la lista de deseos",
        "it": "aggiungi vino alla lista dei desideri",
        "nl": "wijn toevoegen aan verlanglijst",
        "pt": "adicionar vinho à lista de desejos"
    },

    "add to wishlist": {
        "en": "add to wishlist",
        "fr": "ajouter à la liste de souhaits",
        "de": "zur Wunschliste hinzufügen",
        "es": "añadir a la lista de deseos",
        "it": "aggiungi alla lista dei desideri",
        "nl": "toevoegen aan verlanglijst",
        "pt": "adicionar à lista de desejos"
    },

    // NicheEdit page
    
    "Drop your Unit Picture here or Click.": {
        "en": "Drop your Unit Picture here or Click.",
        "fr": "Déposez l’image de votre unité ici ou cliquez.",
        "de": "Legen Sie Ihr Einheitsbild hier ab oder klicken Sie.",
        "es": "Suelte la imagen de su unidad aquí o haga clic.",
        "it": "Rilascia l’immagine della tua unità qui o fai clic.",
        "nl": "Zet je eenheidsafbeelding hier neer of klik.",
        "pt": "Solte a imagem da sua unidade aqui ou clique."
    },

    "name": {
        "en": "name",
        "fr": "nom",
        "de": "name",
        "es": "nombre",
        "it": "nome",
        "nl": "naam",
        "pt": "nome"
    },

    "code": {
        "en": "code",
        "fr": "code",
        "de": "code",
        "es": "código",
        "it": "codice",
        "nl": "code",
        "pt": "código"
    },

    "add unit": {
        "en": "add unit",
        "fr": "ajouter une unité",
        "de": "einheit hinzufügen",
        "es": "añadir unidad",
        "it": "aggiungi unità",
        "nl": "eenheid toevoegen",
        "pt": "adicionar unidade"
    },

    "edit unit": {
        "en": "edit unit",
        "fr": "modifier une unité",
        "de": "einheit bearbeiten",
        "es": "editar unidad",
        "it": "modifica unità",
        "nl": "eenheid bewerken",
        "pt": "editar unidade"
    },

    "unit": {
        "en": "unit",
        "fr": "unité",
        "de": "einheit",
        "es": "unidad",
        "it": "unità",
        "nl": "eenheid",
        "pt": "unidade"
    },

    // EntryShow page
    "from unit": {
        "en": "from unit",
        "fr": "depuis l’unité",
        "de": "aus Einheit",
        "es": "desde la unidad",
        "it": "dall’unità",
        "nl": "uit eenheid",
        "pt": "da unidade"
    },

    "to unit": {
        "en": "to unit",
        "fr": "vers l’unité",
        "de": "zur Einheit",
        "es": "a la unidad",
        "it": "all’unità",
        "nl": "naar eenheid",
        "pt": "para a unidade"
    },

    "owner": {
        "en": "owner",
        "fr": "propriétaire",
        "de": "Besitzer",
        "es": "propietario",
        "it": "proprietario",
        "nl": "eigenaar",
        "pt": "proprietário"
    },

    "tasting note": {
        "en": "tasting note",
        "fr": "note de dégustation",
        "de": "verkostungsnotiz",
        "es": "nota de cata",
        "it": "nota di degustazione",
        "nl": "proefnotitie",
        "pt": "nota de prova"
    },

    "tasting notes": {
        "en": "tasting notes",
        "fr": "notes de dégustation",
        "de": "verkostungsnotizen",
        "es": "notas de cata",
        "it": "note di degustazione",
        "nl": "proefnotities",
        "pt": "notas de prova"
    },

    "appearance": {
        "en": "appearance",
        "fr": "apparence",
        "de": "Aussehen",
        "es": "aspecto",
        "it": "aspetto",
        "nl": "uiterlijk",
        "pt": "aparência"
    },
    "nose": {
        "en": "nose",
        "fr": "nez",
        "de": "Nase",
        "es": "nariz",
        "it": "naso",
        "nl": "neus",
        "pt": "nariz"
    },
    "palate": {
        "en": "palate",
        "fr": "bouche",
        "de": "Gaumen",
        "es": "boca",
        "it": "palato",
        "nl": "mond",
        "pt": "palato"
    },
    "conclusions": {
        "en": "conclusions",
        "fr": "conclusions",
        "de": "Schlussfolgerungen",
        "es": "conclusiones",
        "it": "conclusioni",
        "nl": "conclusies",
        "pt": "conclusões"
    },

    "transfer": {
        "en": "transfer",
        "fr": "transférer",
        "de": "übertragen",
        "es": "transferir",
        "it": "trasferire",
        "nl": "overdragen",
        "pt": "transferir"
    },

    "transfer entry to other unit": {
        "en": "transfer entry to other unit",
        "fr": "transférer l'entrée vers une autre unité",
        "de": "Eintrag in eine andere Einheit übertragen",
        "es": "transferir entrada a otra unidad",
        "it": "trasferisci voce ad altra unità",
        "nl": "verplaats item naar andere eenheid",
        "pt": "transferir entrada para outra unidade"
    },

    "add tasting note": {
        "en": "add tasting note",
        "fr": "ajouter une note de dégustation",
        "de": "verkostungsnotiz hinzufügen",
        "es": "añadir nota de cata",
        "it": "aggiungi nota di degustazione",
        "nl": "proefnotitie toevoegen",
        "pt": "adicionar nota de degustação"
    },

    "edit tasting note": {
        "en": "edit tasting note",
        "fr": "modifier la note de dégustation",
        "de": "verkostungsnotiz bearbeiten",
        "es": "editar nota de cata",
        "it": "modifica nota di degustazione",
        "nl": "proefnotitie bewerken",
        "pt": "editar nota de degustação"
    },

    "add": {
        "en": "add",
        "fr": "ajouter",
        "de": "hinzufügen",
        "es": "añadir",
        "it": "aggiungi",
        "pt": "adicionar",
        "nl": "toevoegen"
    },

    "add bottles": {
        "en": "add bottles",
        "fr": "ajouter des bouteilles",
        "de": "Flaschen hinzufügen",
        "es": "añadir botellas",
        "it": "aggiungi bottiglie",
        "nl": "flessen toevoegen",
        "pt": "adicionar garrafas"
    },

    "remove bottles": {
        "en": "remove bottles",
        "fr": "retirer des bouteilles",
        "de": "Flaschen entfernen",
        "es": "quitar botellas",
        "it": "rimuovere bottiglie",
        "nl": "flessen verwijderen",
        "pt": "remover garrafas"
    },

    "edit transaction": {
        "en": "edit transaction",
        "fr": "modifier la transaction",
        "de": "transaktion bearbeiten",
        "es": "editar transacción",
        "it": "modifica transazione",
        "nl": "transactie bewerken",
        "pt": "editar transação"
    },

    "delete transaction": {
        "en": "delete transaction",
        "fr": "supprimer la transaction",
        "de": "transaktion löschen",
        "es": "eliminar transacción",
        "it": "elimina transazione",
        "nl": "transactie verwijderen",
        "pt": "excluir transação"
    },

    "in stock": {
        "en": "in stock",
        "fr": "en stock",
        "de": "auf Lager",
        "es": "en stock",
        "it": "in magazzino",
        "nl": "op voorraad",
        "pt": "em stock"
    },

    // Dashboard language check

    "Your chosen language is": {
            "en": "Your chosen language is",
        "fr": "Votre langue choisie est le",
        "de": "Ihre gewählte Sprache ist",
        "es": "Su idioma elegido es",
        "it": "La tua lingua scelta è il",
        "nl": "Uw gekozen taal is",
        "pt": "O seu idioma escolhido é"
    },

    "while your profile language is": {
        "en": "while your profile language is",
        "fr": "tandis que la langue de votre profil est",
        "de": "während Ihre Profilsprache ist",
        "es": "mientras que el idioma de su perfil es",
        "it": "mentre la lingua del tuo profilo è il",
        "nl": "terwijl de taal van uw profiel is",
        "pt": "enquanto o idioma do seu perfil é"
    },

    "Option 1: Shall I switch over to your profile language and continue in": {
        "en": "Option 1: Shall I switch over to your profile language and continue in",
        "fr": "Option 1: Dois-je passer à la langue de votre profil et continuer en",
        "de": "Option 1: Soll ich zur Sprache Ihres Profils wechseln und in",
        "es": "Opción 1: ¿Debo cambiar al idioma de su perfil y continuar en",
        "it": "Opzione 1: Devo passare alla lingua del tuo profilo e continuare in",
        "nl": "Optie 1: Zal ik overschakelen naar de taal van uw profiel en doorgaan in",
        "pt": "Opção 1: Devo mudar para o idioma do seu perfil e continuar em"
    },

    "Option 2: Shall I change your profile language to": {
        "en": "Option 2: Shall I change your profile language to",
        "fr": "Option 2: Dois-je changer la langue de votre profil en",
        "de": "Option 2: Soll ich Ihre Profilsprache ändern auf",
        "es": "Opción 2: ¿Debo cambiar el idioma de su perfil a",
        "it": "Opzione 2: Devo cambiare la lingua del tuo profilo",
        "nl": "Optie 2: Zal ik de taal van uw profiel wijzigen naar",
        "pt": "Opção 2: Devo alterar o idioma do seu perfil para"
    },

    "and continue in": {
        "en": "and continue in",
        "fr": "et continuer en",
        "de": "und fortfahren auf",
        "es": "y continuar en",
        "it": "e continuare in",
        "nl": "en doorgaan in",
        "pt": "e continuar em"
    }
}

export function translate_word(string, language) {
    let local_debug = false
    if (local_debug) console.log("original:", string)
    if (wordlist[string] && wordlist[string][language]) {
        if (local_debug) console.log("translation:", wordlist[string][language])
        return wordlist[string][language];
    } else {
        if (local_debug) console.log("translation:", string)
        return string;
    }
}

export const synonyms_by_language = {
  en: {
    // Colors
    white: "white",
    red: "red",
    rose: "rose",

    // Styles
    sparkling: "sparkling",
    sweet: "sweet",

    // Countries
    france: "france",
    spain: "espana",
    italy: "italia",
    germany: "deutschland",
    austria: "osterreich",
    portugal: "portugal",
    greece: "ellada",
  },

  fr: {
    // Colors
    blanc: "white",
    rouge: "red",
    rose: "rose",

    // Styles
    mousseux: "sparkling",
    petillant: "sparkling",
    effervescent: "sparkling",

    doux: "sweet",
    moelleux: "sweet",

    // Countries
    france: "france",
    espagne: "espana",
    italie: "italia",
    allemagne: "deutschland",
    autriche: "osterreich",
    portugal: "portugal",
    grece: "ellada",
  },

  nl: {
    // Colors
    wit: "white",
    rood: "red",
    rose: "rose",

    // Styles
    mousserend: "sparkling",

    zoet: "sweet",

    // Countries
    frankrijk: "france",
    spanje: "espana",
    italie: "italia",
    duitsland: "deutschland",
    oostenrijk: "osterreich",
    portugal: "portugal",
    griekenland: "ellada",
  },

  de: {
    // Colors
    weiss: "white",
    rot: "red",
    rose: "rose",

    // Styles
    schaumwein: "sparkling",
    perlwein: "sparkling",

    suss: "sweet",

    // Countries
    frankreich: "france",
    spanien: "espana",
    italien: "italia",
    deutschland: "deutschland",
    osterreich: "osterreich",
    portugal: "portugal",
    griechenland: "ellada",
  },

  es: {
    // Colors
    blanco: "white",
    rojo: "red",
    rosado: "rose",

    // Styles
    espumoso: "sparkling",

    dulce: "sweet",

    // Countries
    francia: "france",
    espana: "espana",
    italia: "italia",
    alemania: "deutschland",
    austria: "osterreich",
    portugal: "portugal",
    grecia: "ellada",
  },

  it: {
    // Colors
    bianco: "white",
    rosso: "red",
    rosato: "rose",

    // Styles
    spumante: "sparkling",
    frizzante: "sparkling",

    dolce: "sweet",

    // Countries
    francia: "france",
    spagna: "espana",
    italia: "italia",
    germania: "deutschland",
    austria: "osterreich",
    portogallo: "portugal",
    grecia: "ellada",
  },

  pt: {
    // Colors
    branco: "white",
    tinto: "red",
    rose: "rose",

    // Styles
    espumante: "sparkling",

    doce: "sweet",

    // Countries
    franca: "france",
    espanha: "espana",
    italia: "italia",
    alemanha: "deutschland",
    austria: "osterreich",
    portugal: "portugal",
    grecia: "ellada",
  }
}

export function normalize_search_text(value, language = "en") {
  let text = String(value || "")
    .toLowerCase()
    .trim()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "") // Remove accents
    .replace(/ß/g, "ss")
    .replace(/æ/g, "ae")
    .replace(/œ/g, "oe")
    .replace(/[-_/]/g, " ")          // Pays-Bas -> pays bas
    .replace(/\s+/g, " ")            // Collapse whitespace

  const synonyms = synonyms_by_language[language] || {}

  return text
    .split(" ")
    .map(word => synonyms[word] || word)
    .join(" ")
}